import { InjectionToken } from '@angular/core';
import { DateTime } from 'luxon';
import { z } from 'zod';

export interface IIqMcUtilsStateService {}

export enum McUserPermissions {
    EnableMarketConditionsForecast = 'Enable Market Conditions Forecast',
}

export enum MCDashboardIds {
    SingleSearchDashboard = 'mc-single-search-dashboard',
    DoubleSearchDashboardLeft = 'mc-double-search-dashboard-left',
    DoubleSearchDashboardRight = 'mc-double-search-dashboard-right',
}

export const EquipmentTypeParamsSchema = z.enum(['VAN', 'REEFER', 'FLATBED']);

export type EquipmentTypeParams = z.infer<typeof EquipmentTypeParamsSchema>;

export const GeoTypeParamsSchema = z.enum([
    'COUNTRY',
    'REGION',
    'STATE',
    'XMA',
    'KMA',
    'THREEDZ',
]);

export type GeoTypeParams = z.infer<typeof GeoTypeParamsSchema>;

export const TimeframeParamsSchema = z.enum([
    '30_DAYS_BACK',
    '8_DAYS_BACK',
    'PREV_BUSINESS_DAY',
    'CURRENT',
    'FORECAST',
]);

export type TimeframeParams = z.infer<typeof TimeframeParamsSchema>;

export const DirectionParamsSchema = z.enum(['IN', 'OUT']);

export type DirectionParams = z.infer<typeof DirectionParamsSchema>;

export const McRouteParamsSchema = z.object({
    equipmentType: EquipmentTypeParamsSchema,
    geoType: GeoTypeParamsSchema,
    timeframe: TimeframeParamsSchema,
    direction: DirectionParamsSchema,
    geoCode: z.string().default(''),
    displayName: z.string().default(''),
    daysForward: z.number().default(0),
});

export type McRouteParams = z.infer<typeof McRouteParamsSchema>;

export const MC_MAP_GOOGLE_API_KEY = new InjectionToken<string>(
    'The Google Map API Key for the MC Map Lane',
    {
        providedIn: 'root',
        factory: () => '',
    },
);

export const isMciUpdating = () => {
    const now = DateTime.now().setZone('UTC-8').toLocal().toJSDate();
    const start = DateTime.now()
        .setZone('UTC-8')
        .set({ hour: 0, minute: 0 })
        .toLocal()
        .toJSDate();
    
    const end = DateTime.now()
        .setZone('UTC-8')
        .set({ hour: 4, minute: 0 })
        .toLocal()
        .toJSDate();
        
    return now >= start && now < end;
}
